<div fxFlex fxLayout="row" class="mat-form-field">
  <mat-select [formControl]="locationFormControl" [multiple]="isMultiple">
    <mat-option *ngIf="locations.length > 1">
      <ngx-mat-select-search
        [formControl]="locationFilterCtrl"
        [placeholderLabel]="'facility-selector.search-facilities' | translate"
        [noEntriesFoundLabel]="'facility-selector.no-matching-facilities' | translate"
      >
      </ngx-mat-select-search>
    </mat-option>
    <mmx-select-all-option
      *ngIf="isMultiple"
      [control]="locationFormControl"
      [values]="facilityIds"
    ></mmx-select-all-option>
    <mat-option
      *ngFor="let location of filteredLocations | async"
      [value]="isFull ? location : location.id"
    >
      {{ location.fullName }}
    </mat-option>
  </mat-select>
</div>
